import { Injectable } from '@angular/core';
import { fieldsToMapValidation } from '@shared/missing-fields/consts';

@Injectable({ providedIn: 'root' })
export class ValidationI18nMapperService {
  constructor() {}

  public mapValidationStr(strToMap: string): string {
    const fieldIndex: number = fieldsToMapValidation.findIndex((item: { [key: string]: string[] }) => {
      const possibleValues: [string, string[]] = Object.entries(item)?.[0];
      return !!(possibleValues?.[1] || []).includes(strToMap);
    });

    if (fieldIndex >= 0) {
      return Object.keys(fieldsToMapValidation[fieldIndex])?.[0];
    }

    return strToMap;
  }
}
